(function () {
    'use strict';

    angular.module('app')
        .factory('Exportar', Exportar);

    /* @ngInject */
    function Exportar($http, ModalService) {
        return {
            exportar: exportar
        };

        //se exporta a pdf o se envia por email
        function exportar(filtro) {
            if(filtro.formatoExportacion=="PDF"){
                exportarAuxPdf(filtro, 'api/public/edicion/exportar');
            }else{
                exportarAuxMail(filtro, 'api/public/edicion/exportar');
            }
        }

        function exportarAuxPdf(filtro, url) {
            // TODO: Mover a un servicio que reciba la URL y los parámetros. Habría que recibirlos como atributos, sin utilizar un tag
            $http({
                method: 'POST',
                url: url,
                params: {edicionFilter: filtro},
                data: filtro,
                isArray: false,
                responseType: "arraybuffer"
            }).then(function (result) {
                console.log(result);
                var file = new Blob([result.data], {type: 'application/pdf'});
                var contentDisposition = result.headers("Content-Disposition");
                var filename = contentDisposition.split(";")[1].trim().split('=')[1].replace(/"/g, '');
                saveAs(file, filename);
            });
        }

        function exportarAuxMail(filtro, url) {
            $http({
                method: 'POST',
                url: url,
                params: {edicionFilter: filtro},
                data: filtro,
                isArray: false
            }).then(function () {
                ModalService.dismiss('cancel');

            });
        }
    }



})();
